import React from "react";
import Chart from "react-apexcharts";
import { fmtCurrency } from "./analyticsUtils";

const PALETTE = [
    "#0085db", "#5f2dde", "#22c55e", "#f59e0b", "#DB2426",
    "#0ea5e9", "#a855f7", "#14b8a6", "#ef4444", "#64748b",
];

// Collapse a long list of departments into top-N + "Other".
const topWithOther = (items, valueKey, max = 8) => {
    const sorted = [...items].sort((a, b) => (b[valueKey] || 0) - (a[valueKey] || 0));
    if (sorted.length <= max) return sorted;
    const head = sorted.slice(0, max);
    const rest = sorted.slice(max);
    const otherValue = rest.reduce((sum, it) => sum + (it[valueKey] || 0), 0);
    return [...head, { department: "Other", [valueKey]: otherValue }];
};

const DepartmentDonut = ({ salesDepartments = [] }) => {
    const items = topWithOther(
        salesDepartments.filter((d) => (d.revenue || 0) > 0),
        "revenue"
    );
    const labels = items.map((d) => d.department);
    const series = items.map((d) => Math.round((d.revenue || 0) * 100) / 100);
    const hasData = series.some((v) => v > 0);

    const options = {
        chart: { fontFamily: "inherit" },
        labels,
        colors: PALETTE,
        legend: { position: "bottom", fontSize: "12px" },
        dataLabels: { enabled: true, formatter: (val) => `${val.toFixed(0)}%` },
        stroke: { width: 0 },
        plotOptions: {
            pie: {
                donut: {
                    size: "62%",
                    labels: {
                        show: true,
                        total: {
                            show: true,
                            label: "Revenue",
                            fontSize: "12px",
                            formatter: (w) =>
                                fmtCurrency(w.globals.seriesTotals.reduce((a, b) => a + b, 0)),
                        },
                    },
                },
            },
        },
        tooltip: { y: { formatter: (val) => fmtCurrency(val) } },
    };

    return (
        <div className="bg-white rounded-2xl shadow-1 p-4 h-full">
            <div className="flex items-center justify-between mb-2">
                <h3 className="font-bold text-slate-800 text-[15px]">Sales by Department</h3>
            </div>
            {hasData ? (
                <Chart options={options} series={series} type="donut" height={300} />
            ) : (
                <div className="h-[300px] flex-center text-slate-400 text-[13px]">
                    No department sales in this period.
                </div>
            )}
        </div>
    );
};

export default DepartmentDonut;
